import styled from 'styled-components'

interface CenteredProps {
    horizontal?: Boolean
    vertical?: Boolean
}

const Centered = styled.div<CenteredProps>`
    display: flex;

    ${({ horizontal = false, vertical = false }) => {
        if (horizontal && vertical) {
            return `
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
      `
        }

        if (horizontal) {
            return `
        justify-content: center;
        width: 100%;
      `
        }

        if (vertical) {
            return `
        align-items: center;
        height: 100%;
      `
        }
    }}
`

export default Centered
